import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControlDirective, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LookupService } from 'projects/shared/core/services/lookup.service';
import { BaseUiFormControl } from '../base-ui-form-control';

@Component({
  selector: 'ui-autocomplete',
  templateUrl: './ui-autocomplete.component.html',
  styleUrls: ['./ui-autocomplete.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UiAutocompleteComponent),
    multi: true
  }]
})
// -------------------------------------------------
// value returned is a lookup value - {id, display}
// -------------------------------------------------

export class UiAutocompleteComponent extends BaseUiFormControl implements ControlValueAccessor, OnInit {
  @ViewChild(FormControlDirective) formControlDirective: FormControlDirective;

  @Input() lookup: any[] = [];
  @Input() lookupName: string = "";
  @Input() placeholder?: string = "Select an Option";
  @Input() disabled: boolean;
  
  @Output() change = new EventEmitter();

  filteredOptions: any[] = [];
  onChange: any = () => {};
  onTouched: any = () => {};

  get value() {
    return this.control.value;
  }
  set value(value) {
    this.onTouched();
  }
  
  constructor(
    controlContainer: ControlContainer,
    private _lookupService: LookupService) {
    super(controlContainer);
  }

  ngOnInit(): void {
    (this.control as FormControl).registerOnChange(() => {
      this.lookup = this._lookupService.get(this.lookupName);
    });
    if (this.lookupName) {
      this.lookup = this.lookup.length == 0 ? this._lookupService.get(this.lookupName) : this.lookup;
    }
  }

  clear() {
    this.writeValue("");
    this.control.setValue("");
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled && this.control.enabled) this.control.disable();
    else if (!isDisabled && this.control.disabled) this.control.enable();
  }

  validate(_: FormControl) {
    return this.control.valid ? null : { profile: { valid: false } };
  }

  writeValue(obj: any): void {
    if (obj) {
      this.value = obj;
    }
  }

  onFilterOptions(event) {
    let options: any[] = this.lookup;
    let filteredOptions: any[] = [];
    for(let index = 0; index < options.length; index++)  {
      let option = options[index];
      if (option.display.toLowerCase().indexOf(event.query.toLowerCase()) >= 0) {
        filteredOptions.push(option);
      }
    }
    this.filteredOptions = filteredOptions;
  }

}
